import React from 'react';

const PARTNERS = [
  {
    name: '김민지 대표',
    location: '강남점 운영 2년차',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBTWlw8K5lYC2p2QjW10G0DNTqlTm__0sYTpmzYbYJTbwpdb_Q-yArUe7cAHaVkY2vIObHQJKovD407vFwS58USV7lvKXdrrBdy2PBjrFJKl_SWuXPavXA4qbit7SHRTBxMYp3HFd4-4rPXJ8dMG6qSVN66YgAPAd3e03txdeVXvNVYjG4eeALifRHlM4XppgqpPHresgnzprnT99nr4NxyMCHlPWICgBJe8SQDSWkEw2gHtkZ-Jp6NigolIL_cbXPoqRxvmEZPHUuf',
    stars: 5,
    quote: '"처음엔 부업으로 시작했지만, 지금은 본업 수입의 3배가 넘었습니다. 자동화된 시스템 덕분에 시간 여유도 생겼어요."',
    statLabel: 'Monthly Profit',
    statValue: '+350% 성장',
  },
  {
    name: '박성훈 대표',
    location: '부산점 운영 1년차',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDqFnqz_yMxm8zV7pdEraBql_u3CPsoYxG66-Bc1ZkOIWox4_oGLWUySB5exrnXCitMfKh27V-Uy3EGSGM3defQ6KKwv1NTLBrNxdPX4Sl33Nhoj-k2AER9Hpp6_VXZDnGGE-i_k9vVuGKkPGoQDl9OLfuLjWzl1J6eiBICmNNqBeybG48pUrFrJelfOk3qgA0VYqMoB-8iGmmUmhzuKlTPpeiTl5xqlVvl7PI_OMgslSbr2m_ZWl4tXl2aRhDpnegZtJaQ11I0-_Jq',
    stars: 5,
    quote: '"화훼에 대한 지식이 전혀 없었지만, 본사의 체계적인 교육과 브랜딩 덕분에 빠르게 자리를 잡을 수 있었습니다."',
    statLabel: 'Reorder Rate',
    statValue: '85% 달성',
  },
  {
    name: '최영희 대표',
    location: '온라인 전용몰 운영',
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuC3qewzwdAabgY4rdKF-Btwj3JH7GnbecfJppOv6SzZfuI5ifADT8A9ZiWR02eMeOncA8xELvFY_QHolKqt8Kbw2O6i5pk535tfurQyHRe3qVFy1LydtxHqjKD79OhELcObbFaKgvV7cgfNUbeNEV1cwWiHeDDH-budx0vguf6ByN4LIqzT3_Pkw7zPG7U1KOZHrvFPT1wUlCrI8UxrOJoon1cYLw4bQHpl0neAbQPP6fB5sd2IbXS0qSEQnPpwJdK_SdLI68f9eu4m',
    stars: 4.5,
    quote: '"오프라인 매장 없이 온라인으로만 운영하는데도, 전국 네트워크 덕분에 배송 걱정이 없어 너무 편합니다."',
    statLabel: 'Operational Cost',
    statValue: '50% 절감',
  },
];

function StarRating({ count }) {
  const fullStars = Math.floor(count);
  const hasHalf = count % 1 !== 0;
  return (
    <div className="flex gap-1 text-primary mb-3">
      {Array.from({ length: fullStars }, (_, i) => (
        <span key={i} className="material-symbols-outlined text-lg">star</span>
      ))}
      {hasHalf && <span className="material-symbols-outlined text-lg">star_half</span>}
    </div>
  );
}

function PartnerCard({ partner }) {
  return (
    <div className="flex flex-col gap-4">
      <div className="relative h-64 rounded-xl overflow-hidden mb-2 group">
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
          style={{ backgroundImage: `url("${partner.image}")` }}
        >
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-4 left-4 text-white">
          <p className="font-bold text-lg">{partner.name}</p>
          <p className="text-sm opacity-90">{partner.location}</p>
        </div>
      </div>
      <div className="p-4 bg-white dark:bg-surface-dark rounded-xl border border-gray-100 dark:border-gray-800 shadow-sm">
        <StarRating count={partner.stars} />
        <p className="text-gray-600 dark:text-gray-300 italic mb-4">{partner.quote}</p>
        <div className="pt-4 border-t border-gray-100 dark:border-gray-700 flex justify-between items-center">
          <span className="text-xs font-bold text-gray-400 uppercase">{partner.statLabel}</span>
          <span className="text-primary font-bold">{partner.statValue}</span>
        </div>
      </div>
    </div>
  );
}

function PartnersSection() {
  return (
    <section className="py-20 md:py-32 px-4 md:px-10 max-w-[1280px] mx-auto" id="partners">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">성공 파트너 이야기</h2>
        <p className="text-gray-500 dark:text-gray-400">수많은 파트너들이 이미 놀라운 성장을 경험하고 있습니다.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {PARTNERS.map((partner) => (
          <PartnerCard key={partner.name} partner={partner} />
        ))}
      </div>
    </section>
  );
}

export default PartnersSection;
